import { render, staticRenderFns } from "./anti-fraud-result.vue?vue&type=template&id=e85f2208&scoped=true"
import script from "./anti-fraud-result.vue?vue&type=script&lang=ts"
export * from "./anti-fraud-result.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85f2208",
  null
  
)

export default component.exports